"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _tabSourcesSelector = require("./tabSourcesSelector");
Object.keys(_tabSourcesSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tabSourcesSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tabSourcesSelector[key];
    }
  });
});
var _screenShareSelector = require("./screenShareSelector");
Object.keys(_screenShareSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _screenShareSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _screenShareSelector[key];
    }
  });
});
var _programSourceSelector = require("./programSourceSelector");
Object.keys(_programSourceSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _programSourceSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _programSourceSelector[key];
    }
  });
});
var _broadcastSourcesSelector = require("./broadcastSourcesSelector");
Object.keys(_broadcastSourcesSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _broadcastSourcesSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _broadcastSourcesSelector[key];
    }
  });
});
var _maxCameraSourcesOnSelector = require("./maxCameraSourcesOnSelector");
Object.keys(_maxCameraSourcesOnSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _maxCameraSourcesOnSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _maxCameraSourcesOnSelector[key];
    }
  });
});
var _pendingKnockRequestSelector = require("./pendingKnockRequestSelector");
Object.keys(_pendingKnockRequestSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pendingKnockRequestSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pendingKnockRequestSelector[key];
    }
  });
});
var _isAttendeeTalkingSelector = require("./isAttendeeTalkingSelector");
Object.keys(_isAttendeeTalkingSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isAttendeeTalkingSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _isAttendeeTalkingSelector[key];
    }
  });
});
var _presentationOnStageSelector = require("./presentationOnStageSelector");
Object.keys(_presentationOnStageSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _presentationOnStageSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _presentationOnStageSelector[key];
    }
  });
});
var _localSourceSelector = require("./localSourceSelector");
Object.keys(_localSourceSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _localSourceSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _localSourceSelector[key];
    }
  });
});